import { formatINR } from "@/lib/format";

export const COLORS = ["#1A1F16", "#2E6F40", "#A67C00", "#D94F3D", "#6C7565", "#3C4537", "#8B7355"];

// Static chart props hoisted to module scope so recharts children don't get new object refs each render.
export const CHART_MARGIN = { top: 10, right: 12, left: 0, bottom: 0 };
export const VERTICAL_CHART_MARGIN = { top: 0, right: 12, left: 0, bottom: 0 };
export const AXIS_LINE = { stroke: "#D8D4C7" };
export const TOOLTIP_STYLE = { background: "#FFF", border: "1px solid #D8D4C7", borderRadius: 0, fontSize: 12 };
export const BAR_CURSOR = { fill: "#EAE7DD", opacity: 0.4 };
export const LEGEND_STYLE = { fontSize: 11, textTransform: "uppercase", letterSpacing: "0.1em" };
export const SAVINGS_DOT = { r: 2 };
export const inrTick = (v) => formatINR(v, { compact: true });
export const inrValue = (v) => formatINR(v);
